import { createBrowserRouter, Navigate } from "react-router-dom";
import Login from "./views/Login.jsx";
import Dashboard from "./views/Dashboard.jsx";
import TeamsDashboard from "./views/TeamsDashboard.jsx";
import DefaultLayout from "./components/Layouts/DefaultLayout.jsx";
import GuestLayout from "./components/Layouts/GuestLayout.jsx";
import NotFound from "./views/NotFound";
import Orders from "./views/Orders.jsx";
import Settings from "./views/Settings.jsx";
import RoleSettings from "./views/RoleSettings.jsx";
import Users from "./views/Users.jsx";
import UserForm from "./views/UserForm.jsx";
import PermissionSettings from "./views/PermissionSettings.jsx";
import CompanySettings from "./views/CompanySettings.jsx";
import ProductSettings from "./views/ProductSettings.jsx";
import TeamSettings from "./views/TeamSettings.jsx";
import ReadyStock from "./views/ReadyStock.jsx";
import FabricStore from "./views/FabricStore.jsx";
import FabricProduction from "./views/FabricProduction.jsx";
import FabricSales from "./views/FabricSales.jsx";
import FabricRequests from "./views/FabricRequests.jsx";
import FabricPayments from "./views/FabricPayments.jsx";
import FabricReceipts from "./views/FabricReceipts.jsx";
import MarketplaceSettings from "./views/MarketplaceSettings.jsx";
import Order from "./views/Order.jsx";
import Error from "./views/Error";
import OrderFormPage from "./views/OrderFormPage";
import UserProfile from "./views/UserProfile";
import ResetPassword from "./views/ResetPassword";
import Customers from "./views/Customers";

const router = createBrowserRouter([
  {
    path: '/',
    element: <DefaultLayout />,
    children: [
      {
        path: '/',
        element: <Dashboard />
      },
      {
        path: '/dashboard',
        element: <Dashboard />
      },
      {
        path: '/dashboard/teams',
        element: <TeamsDashboard />
      },
      {
        path: '/profile',
        element: <UserProfile />
      },
      {
        path: '/orders',
        element: <Orders />
      },
      {
        path: '/orders/orderForm',
        element: <OrderFormPage mode="create" />
      },
      {
        path: '/orders/editOrderForm',
        element: <OrderFormPage mode="edit" />
      },
      {
        path: '/orders/:id',
        element: <Order />
      },
      {
        path: '/orders/:id/edit',
        element: <OrderFormPage mode="edit" />
      },
      {
        path: '/settings',
        element: <Settings />,
      },
      {
        path: '/users',
        element: <Users />,
      },
      {
        path: '/users/userForm',
        element: <UserForm />,
      },
      {
        path: '/users/:userName',
        element: <UserProfile />,
      },
      {
        path: '/settings/companySettings',
        element: <CompanySettings />
      },
      {
        path: '/settings/roleSettings',
        element: <RoleSettings />
      },
      {
        path: '/settings/permissionSettings',
        element: <PermissionSettings />
      },
      {
        path: '/settings/productSettings',
        element: <ProductSettings />
      },
      {
        path: '/settings/teamSettings',
        element: <TeamSettings />
      },
      {
        path: '/settings/marketplaceSettings',
        element: <MarketplaceSettings />
      },
      {
        path: '/notFound',
        element: <NotFound />
      },
      {
        path: '/resetPassword',
        element: <ResetPassword />
      },
      {
        path: '/customers',
        element: <Customers />
      },
      {
        path: '/merchants',
        element: <Navigate to="/customers?view=dormant" replace />
      },
      {
        path: '/stock',
        element: <ReadyStock />
      },
      {
        path: '/fabricStore',
        element: <FabricStore />
      },
      {
        path: '/fabricRequests',
        element: <FabricRequests />
      },
      {
        path: '/fabricProduction',
        element: <FabricProduction />
      },
      {
        path: '/fabricSales',
        element: <FabricSales />
      },
      {
        path: '/fabricPayments',
        element: <FabricPayments />
      },
      {
        path: '/fabricReceipts',
        element: <FabricReceipts />
      }
    ]
  },
  {
    path: '/',
    element: <GuestLayout />,
    children: [
      {
        path: '/login',
        element: <Login />
      },
      {
        path: '/error',
        element: <Error />
      }
    ]
  },
  {
    path: '*',
    element: <NotFound />
  }

]);

export default router;
